import { pageFactory } from '@/core/factories/pageFactory'
import workspace from '@bees-web/nfa-interactive-home'

const nextPage = pageFactory({
  workspace,
  template: 'home_guest_homepage',
  pageKey: 'GUEST_HOMEPAGE',
  dependencies: [],
  trackName: 'Guest Homepage',
  options: {
    processDeferredOnServer: true,
    cachePage: true,
    noAuthentication: true
  }
})

export default nextPage.Page

export const getServerSideProps = nextPage.getServerSideProps
